import { render, staticRenderFns } from "./addressPop.vue?vue&type=template&id=71a6dc99&scoped=true"
import script from "./addressPop.vue?vue&type=script&lang=js"
export * from "./addressPop.vue?vue&type=script&lang=js"
import style0 from "./addressPop.vue?vue&type=style&index=0&id=71a6dc99&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6dc99",
  null
  
)

export default component.exports